import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export interface ScenarioManifestEntry {
  id: string;
  name: string;
  iterScope: string;
  part?: string;
  tags: string[];
  prerequisites: string | null;
  purpose: string;
  checklist: string[];
  path: string;
  eventUrl?: string;
  djLogin?: { email: string; password: string };
}

interface SeedDocument {
  collection: string;
  docId: string;
  data: Record<string, unknown>;
}

interface SeedResult {
  success: boolean;
  scenarioPath: string;
  documentCount: number;
  seededAt: string;
}

interface CleanResult {
  success: boolean;
  deletedCount: number;
}

export async function fetchManifest(): Promise<ScenarioManifestEntry[]> {
  const response = await fetch('/testing/scenarios/manifest.json');
  if (!response.ok) {
    throw new Error(`Failed to fetch manifest: ${response.statusText}`);
  }
  return response.json();
}

export async function seedScenario(
  scenarioPath: string,
  documents: SeedDocument[]
): Promise<SeedResult> {
  const callable = httpsCallable<
    { scenarioPath: string; documents: SeedDocument[] },
    SeedResult
  >(functions, 'seedScenario');
  const result = await callable({ scenarioPath, documents });
  return result.data;
}

export async function cleanTestData(): Promise<CleanResult> {
  const callable = httpsCallable<Record<string, never>, CleanResult>(
    functions,
    'cleanTestData'
  );
  const result = await callable({});
  return result.data;
}

const CHECKLIST_STORAGE_KEY = 'votebeats-test-harness-checklists';

export function loadChecklistState(): Record<string, boolean[]> {
  try {
    const stored = localStorage.getItem(CHECKLIST_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}

export function saveChecklistState(state: Record<string, boolean[]>): void {
  localStorage.setItem(CHECKLIST_STORAGE_KEY, JSON.stringify(state));
}

export function clearChecklistState(scenarioPath: string): void {
  const state = loadChecklistState();
  delete state[scenarioPath];
  saveChecklistState(state);
}

export function clearAllChecklistState(): void {
  localStorage.removeItem(CHECKLIST_STORAGE_KEY);
}
